"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// source: https://www.iso.org/obp/ui/#iso:code:3166:PT
var _default = [{
  name: 'Aveiro',
  code: 'AVEIRO'
}, {
  name: 'Beja',
  code: 'BEJA'
}, {
  name: 'Braga',
  code: 'BRAGA'
}, {
  name: 'Bragança',
  code: 'BRAGANCA'
}, {
  name: 'Castelo Branco',
  code: 'CASTELOBRANCO'
}, {
  name: 'Coimbra',
  code: 'COIMBRA'
}, {
  name: 'Évora',
  code: 'EVORA'
}, {
  name: 'Faro',
  code: 'FARO'
}, {
  name: 'Guarda',
  code: 'GUARDA'
}, {
  name: 'Leiria',
  code: 'LEIRIA'
}, {
  name: 'Lisboa',
  code: 'LISBOA'
}, {
  name: 'Portalegre',
  code: 'PORTALEGRE'
}, {
  name: 'Porto',
  code: 'PORTO'
}, {
  name: 'Santarém',
  code: 'SANTAREM'
}, {
  name: 'Setúbal',
  code: 'SETUBAL'
}, {
  name: 'Viana do Castelo',
  code: 'VIANADOCASTELO'
}, {
  name: 'Vila Real',
  code: 'VILAREAL'
}, {
  name: 'Viseu',
  code: 'VISEU'
}, {
  name: 'Região Autónoma dos Açores',
  code: 'ACORES'
}, {
  name: 'Região Autónoma da Madeira',
  code: 'MADEIRA'
}];
exports.default = _default;